import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import Localized from "../../Localized";
import "./style.scss";
import { useGetStatisticsCategoryMutation } from "../../redux/api";

import { cloudStorage } from "@telegram-apps/sdk";
import { navigateToPage, setSelectedStatisticType } from "../../redux/slices/windowSlice";
import { CircularProgress } from "@mui/material";

const Dashboard = () => {
    const dispatch = useAppDispatch();
    
    const { dashboard, projectId } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const dashboardItems = dashboard ? Object.entries(dashboard) : [];
    const [loadStatistic, { data, isLoading, isError, isSuccess }] =
        useGetStatisticsCategoryMutation();

    useEffect(() => {
        if (!isLoading && data && !isError) {
            dispatch(navigateToPage("payment_items"));
        } 
    }, [data, isError, isLoading]);

    const [password, setPassword] = useState("");
    const [selectedKey, setSelectedKey] = useState("");

    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            const password = localStorage.getItem("b4chat-password-hash-admin");
            setPassword(password);
        } else {
            cloudStorage
                .getItem("b4chat-password-hash-admin")
                .then((password) => {
                    setPassword(password);
                });
        }
    }, []);

    const handleLoadStatistic = (key: string) => {
        setSelectedKey(key);
        loadStatistic({ type: key, project_id: projectId, password: password });
        dispatch(setSelectedStatisticType(key));
    };

    return (
        <div className="dashboard">
            <div className="dashboard_container">
                <div className="dashboard_wrapper">
                    {dashboardItems.map(([key, value]) => (
                        <div
                            className="dashboard_item"
                            key={key}
                            onClick={() => handleLoadStatistic(key)}>
                                {isLoading && selectedKey == key ? (
                                    <CircularProgress size="25px" thickness={6}  />
                                ) : (
                                    <>
                                        <span className="dashboard_item_count">
                                            {value}
                                        </span>
                                        <span className="dashboard_item_text">
                                            {Localized[key] || key}
                                        </span>
                                    </>
                                )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
